<template>
  <v-progress-linear
    :height="height"
    bg-color="surface-grey-subtle"
    bg-opacity="1"
    class="SubscriptionDataroomStorageBar"
    data-locator="subscription-dataroom-storage-bar"
  >
    <div
      v-for="(segment, index) in segments"
      :key="index"
      class="SubscriptionDataroomStorageBar__segment h-100"
      :style="{ width: `${segment.percent}%`, backgroundColor: `rgb(var(--v-theme-${segment.color}))` }"
    />
  </v-progress-linear>
</template>

<script lang="ts">
  import { defineComponent, type PropType } from 'vue'

  // One filled section: `percent` = width (0-100), color = Vuetify theme color name.
  export type DataroomStorageBarSegment = {
    percent: number
    color: string
  }

  // Shared storage bar: N segments for the forfait distribution, one used/limit segment for a
  // pay-per-use card. Renders the given segments only; storage maths stays in the parent.
  export default defineComponent({
    name: 'SubscriptionDataroomStorageBar',
    props: {
      segments: {
        type: Array as PropType<DataroomStorageBarSegment[]>,
        required: true,
      },
      height: {
        type: Number,
        default: 20,
      },
    },
  })
</script>

<style scoped lang="scss">
  $rounded-sm: 4px;

  .SubscriptionDataroomStorageBar {
    border-radius: $rounded-sm;
    overflow: hidden;
  }

  :deep(.v-progress-linear__content) {
    display: flex;
    justify-content: flex-start;
  }
</style>
